import { Injectable, inject } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

import { AuthenticationService } from '../services/authentication.service';
import { EnvironmentService } from '~/core/services/environment.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  auth = inject(AuthenticationService);

  tokenRequiredURLs: string[] = [EnvironmentService.backendURL, EnvironmentService.backendUserURL, EnvironmentService.transactionURL];

  constructor() {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = this.auth.getToken();
    if ((this.auth.isLoggedIn() || token) && this.isTokenRequiredForURL(request.url)) {
      request = request.clone({
        setHeaders: { Authorization: `Bearer ${token}` },
      });
    }
    return next.handle(request);
  }

  isTokenRequiredForURL(url: string): boolean {
    return this.tokenRequiredURLs.some((base) => url?.includes(base));
  }
}
